const tracks = {};
const fadeTimers = {};
let activeKey = null;
let activeVol = 0.4;

function cancelFade(key) {
    if (fadeTimers[key]) { clearInterval(fadeTimers[key]); delete fadeTimers[key]; }
}

function fadeIn(key, targetVol = 0.4) {
    const audio = tracks[key];
    if (!audio) return;
    cancelFade(key);
    // iOS blocks play() at volume 0 — start at 0.01 then fade up
    audio.volume = 0.01;
    const promise = audio.play();
    if (promise !== undefined) {
        promise.then(() => {
            fadeTimers[key] = setInterval(() => {
                audio.volume = Math.min(audio.volume + 0.02, targetVol);
                if (audio.volume >= targetVol) cancelFade(key);
            }, 80);
        }).catch(() => {});
    }
}

function fadeOut(key, cb) {
    const audio = tracks[key];
    if (!audio || audio.paused) { cb && cb(); return; }
    cancelFade(key);
    fadeTimers[key] = setInterval(() => {
        audio.volume = Math.max(audio.volume - 0.04, 0);
        if (audio.volume <= 0) {
            cancelFade(key);
            audio.pause();
            audio.currentTime = 0;
            cb && cb();
        }
    }, 40);
}

export function playTrack(key, src, targetVol = 0.4) {
    activeKey = key;
    activeVol = targetVol;
    if (localStorage.getItem('sound') === 'off') return;
    if (tracks[key] && !tracks[key].paused) return;

    Object.keys(tracks).forEach(k => { if (k !== key) fadeOut(k); });

    if (!tracks[key]) {
        tracks[key] = new Audio(src);
        tracks[key].loop = true;
    }
    fadeIn(key, targetVol);
}

export function stopTrack(key, cb) {
    if (activeKey === key) activeKey = null;
    fadeOut(key, cb);
}

export function stopAll(cb) {
    activeKey = null;
    const keys = Object.keys(tracks);
    let done = 0;
    if (keys.length === 0) { cb && cb(); return; }
    keys.forEach(k => fadeOut(k, () => {
        done++;
        if (done === keys.length) cb && cb();
    }));
}

export function setMuted(muted) {
    if (muted) {
        Object.keys(tracks).forEach(k => fadeOut(k));
    } else if (activeKey) {
        fadeIn(activeKey, activeVol);
    }
}
